<template>
  <div class="main-bg">
    <page-header title="学习详情" :data="pageHeaderArr" />
    <p style="color: #fff">
      <small>说明：累计观看时长达到该课节的总时长，视为完成该课节的学习。</small>
    </p>
    <ming-table v-model="tableData" v-loading="loading" :fields="scheduleDetailColumn" :array-span-method="arraySpanMethod">
      <template #index="{ scope }">
        {{ scope.parent.index }}
      </template>
      <template #parentTitle="{ scope }">
        {{ scope.parent.title }}
      </template>
      <template #teacher_id="{ scope }">
        {{ scope.teacherInfo ? scope.teacherInfo.name : '-' }}
      </template>
      <template #remark="{ scope }">
        <template v-if="scope.type === 2">
          <div v-if="scope.extra_content && scope.extra_content.sk_date">
            {{ scope.extra_content.sk_date }} {{ scope.extra_content.sk_start_time + '~' + scope.extra_content.sk_end_time }}
          </div>
          <div v-else>-</div>
          <el-button v-if="scope.extra_content && scope.extra_content.remark" type="text" @click="openRemarkDialog(scope)"> 查看 </el-button>
        </template>
        <template v-else> - </template>
      </template>
      <template #back_url="{ scope }">
        <el-button v-if="scope.type === 2 && scope.extra_content?.back_url" type="text" @click="showPlayback(scope)"> 查看 </el-button>
        <template v-else> - </template>
      </template>
      <template #recorded_url="{ scope }">
        <el-button v-if="scope.type === 4 && scope.extra_content?.recorded_url" type="text" @click="showPlayback(scope)"> 查看 </el-button>
        <template v-else> - </template>
      </template>
      <!-- recorded_url -->
      <template #intro="{ scope }">
        <el-button v-if="scope.intro" type="text" @click="showCourseInfo(scope, 'intro')"> 查看 </el-button>
        <span v-else>--</span>
      </template>
      <template #file="{ scope }">
        <el-button v-if="scope.file && scope.file.length" type="text" @click="showCourseInfo(scope, 'file')"> 查看 </el-button>
        <span v-else>--</span>
      </template>
      <template #video_id="{ scope }">
        <el-button v-if="scope.type === 1 && scope.extra_content?.state === 1" type="text" @click="showPlayback(scope)"> 查看 </el-button>
        <template v-else> -- </template>
      </template>
    </ming-table>
    <el-dialog :visible.sync="remarkDialogVisible" title="会议信息">
      <!-- <pre style="white-space: pre-wrap">{{ remarkContent }}</pre> -->
      <el-descriptions v-if="remarkDialogVisible" :column="1" border>
        <el-descriptions-item label="上课时间">
          {{ selectedCourse.extra_content?.sk_start_time || '无' }} - {{ selectedCourse.extra_content?.sk_end_time || '无' }}
        </el-descriptions-item>
        <el-descriptions-item label="教师">
          {{ selectedCourse?.teacherInfo?.name || '无' }}
        </el-descriptions-item>
        <el-descriptions-item label="会议信息">
          <pre style="white-space: pre-wrap">{{ selectedCourse.extra_content?.remark || '无' }}</pre>
        </el-descriptions-item>
        <el-descriptions-item v-if="selectedCourse?.extra_content?.TencentUrl" label="会议地址">
          <a :href="selectedCourse?.extra_content?.TencentUrl" target="_blank">{{ selectedCourse?.extra_content?.TencentUrl }}</a>
        </el-descriptions-item>
        <el-descriptions-item v-if="selectedCourse?.extra_content?.TencentCode" label="会议号">
          {{ selectedCourse?.extra_content?.TencentCode }}
        </el-descriptions-item>
        <el-descriptions-item v-if="selectedCourse?.extra_content?.back_url" label="回放地址">
          <a :href="selectedCourse?.extra_content?.back_url" target="_blank">{{ selectedCourse?.extra_content?.back_url }}</a>
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="remarkDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 新增一个查看章节详情的弹窗 intro,file 两种类型-->
    <el-dialog :visible.sync="dialogVisible" title="课程详情">
      <div v-if="dialogVisible">
        <div v-if="dialogType === 'intro'">{{ selectedCourseInfo.intro }}</div>
        <div v-else-if="dialogType === 'file'">
          <p v-for="(file, index) in selectedCourseInfo.file" :key="index" style="margin-top: 0;">
            <a :href="BASE_URL + file.url" target="_blank" rel="noopener noreferrer">
              {{ file.name }}
            </a>
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script setup>
// 引入必要的模块和组件
import { ref, onMounted } from 'vue'
import PageHeader from '@/components/PageHeader'
import Router from '@/router'
import API from '@/api'
import { scheduleDetailColumn } from './tableColumn'
// 1：录播，2：直播
// 获取路由查询参数

const BASE_URL = process.env.VUE_APP_FILE_URL

const routeQuery = Router.currentRoute.query

// 定义页面头部数据
const pageHeaderArr = ref([
  {
    title: '课程名称',
    value: routeQuery.courseName
  },
  {
    title: '学分',
    value: routeQuery.courseScore
  },
  {
    title: '学时',
    value: routeQuery.courseHour
  }
])
const dialogVisible = ref(false)
const dialogType = ref('')
const selectedCourseInfo = ref('')
const showCourseInfo = (scope, type) => {
  dialogVisible.value = true
  selectedCourseInfo.value = scope
  switch (type) {
    case 'intro':
      dialogType.value = 'intro'
      break
    case 'file':
      dialogType.value = 'file'
      break
    default:
      break
  }
}
const showPlayback = scope => {
  switch (scope.type) {
    case 1:
      Router.push({
        name: 'CourseDetail',
        query: {
          ctId: scope.ct_id,
          course_table_chapter_id: scope.id,
          courseTitle: routeQuery.courseName
        }
      })
      break
    case 2:
      window.open(scope.extra_content.back_url)
      break
    case 4:
      window.open(scope.extra_content.back_url)
      break
    default:
      break
  }
}

// 定义必要的响应式变量
const loading = ref(false)
const tableData = ref([])
const remarkDialogVisible = ref(false)
const selectedCourse = ref('')

// 获取数据
function getData() {
  loading.value = true
  API.MBAChapterDetail(Router.currentRoute.query.ctid)
    .then(res => {
      if (+res.code === 200) {
        tableData.value = flattenData(res.data.list)
        console.log(tableData.value)
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

// 扁平化数据并添加 parent 字段
function flattenData(data) {
  const result = []
  data.forEach((item, index) => {
    if (item.children && item.children.length > 0) {
      item.children.forEach(child => {
        result.push({
          ...child,
          parent: { ...item, childrenLength: item.children.length, index: index + 1 }
        })
      })
    } else {
      result.push({
        typeText: item.typeText,
        parent: { ...item, childrenLength: 0, index: index + 1 }
      })
    }
  })
  return result
}

// 合并单元格
const arraySpanMethod = ({ row, column, rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    if (rowIndex === 0 || tableData.value[rowIndex].parent.title !== tableData.value[rowIndex - 1].parent.title) {
      return {
        rowspan: row.parent.childrenLength || 1,
        colspan: 1
      }
    } else {
      return {
        rowspan: 0,
        colspan: 0
      }
    }
  } else if (columnIndex === 1) {
    if (rowIndex === 0 || tableData.value[rowIndex].parent.title !== tableData.value[rowIndex - 1].parent.title) {
      return {
        rowspan: row.parent.childrenLength || 1,
        colspan: 1
      }
    } else {
      return {
        rowspan: 0,
        colspan: 0
      }
    }
  }
}

// 打开备注信息弹窗
const openRemarkDialog = scope => {
  selectedCourse.value = scope
  remarkDialogVisible.value = true
}

// 组件挂载时获取数据
onMounted(() => {
  getData()
})
</script>
<style lang="scss" scoped></style>
